var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2395 4.51423C10.7867 5.22736 11.0833 6.10112 11.0833 7H12.25C12.25 5.8443 11.8687 4.72089 11.1651 3.804C10.4616 2.88712 9.47512 2.22801 8.3588 1.92889C7.24247 1.62977 6.05864 1.70736 4.99091 2.14963C4.44102 2.37741 3.93775 2.69535 3.5 3.08688V2.33334H2.33333V5.25H5.25V4.08334H4.14226C4.51287 3.72022 4.95175 3.42865 5.43738 3.22749C6.26783 2.88351 7.18859 2.82316 8.05684 3.0558C8.9251 3.28845 9.69232 3.8011 10.2395 4.51423Z",
    fill: "black",
    fillOpacity: 0.76
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76047 9.48578C3.21327 8.77265 2.91667 7.89888 2.91667 7H1.75C1.75 8.15571 2.13135 9.27912 2.8349 10.196C3.53844 11.1129 4.52488 11.772 5.6412 12.0711C6.75753 12.3702 7.94136 12.2926 9.00909 11.8504C9.55898 11.6226 10.0622 11.3047 10.5 10.9131V11.6667H11.6667V8.75H8.75V9.91667H9.85774C9.48713 10.2798 9.04825 10.5714 8.56262 10.7725C7.73217 11.1165 6.81141 11.1768 5.94316 10.9442C5.0749 10.7116 4.30768 10.1989 3.76047 9.48578Z",
    fill: "black",
    fillOpacity: 0.76
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.40e64651ec92b34c6da1aa76b5dbd6eb.svg";
export { ForwardRef as ReactComponent };